// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rvL1","label":"styles_label__wZc_D"};